import React from "react";

function Icon(data) {
  return (
    <svg width={data.w} height={data.h} viewBox="0 0 108 108" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
            <g id="GLOBAL/Icons/System/Close-Schwarz" transform="translate(4.000000, 4.000000)" stroke="#000000" strokeWidth="8">
                <line x1="-6.09337142e-14" y1="100" x2="99.7894737" y2="-7.15509523e-14" id="Path"></line>
                <polyline id="Path" points="-1.23944714e-13 1.24637143e-14 49.7895278 49.894569 64.9322713 65.0692592 99.7894737 100"></polyline>
            </g>
        </g>
    </svg>
  );
}

export default Icon;
